var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.68156 4.65561C7.49079 4.85838 7.1815 4.85838 6.99073 4.65561C6.79996 4.45284 6.79996 4.12408 6.99073 3.92131L9.59599 1.15208C9.69138 1.05069 9.81639 1 9.9414 1C10.0076 1 10.0708 1.01401 10.1284 1.0394C10.186 1.06474 10.24 1.1023 10.2868 1.15208L12.8921 3.92131C13.0828 4.12408 13.0828 4.45284 12.8921 4.65561C12.7013 4.85838 12.392 4.85838 12.2013 4.65561L10.4299 2.77276L10.4299 9.48077C10.4299 9.76753 10.2112 10 9.9414 10C9.67162 10 9.45292 9.76753 9.45292 9.48077L9.45292 2.77276L7.68156 4.65561Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M12.3145 14.445C12.5053 14.2422 12.8146 14.2422 13.0054 14.445C13.1961 14.6477 13.1961 14.9765 13.0054 15.1793L10.4001 17.9485C10.3047 18.0499 10.1797 18.1006 10.0547 18.1006C9.98845 18.1006 9.9253 18.0866 9.8677 18.0612C9.81009 18.0358 9.75611 17.9983 9.70928 17.9485L7.10401 15.1793C6.91325 14.9765 6.91325 14.6477 7.10401 14.445C7.29478 14.2422 7.60407 14.2422 7.79484 14.445L9.5662 16.3278L9.5662 9.61982C9.5662 9.33306 9.7849 9.10059 10.0547 9.10059C10.3245 9.10059 10.5432 9.33306 10.5432 9.61982L10.5432 16.3278L12.3145 14.445Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M15.3444 7.12199C15.1416 6.93122 15.1416 6.62193 15.3444 6.43116C15.5472 6.24039 15.8759 6.24039 16.0787 6.43116L18.8479 9.03642C18.9493 9.13181 19 9.25682 19 9.38183C19 9.44807 18.986 9.51122 18.9606 9.56882C18.9353 9.62643 18.8977 9.68041 18.8479 9.72725L16.0787 12.3325C15.8759 12.5233 15.5472 12.5233 15.3444 12.3325C15.1416 12.1417 15.1416 11.8325 15.3444 11.6417L17.2272 9.87032L10.5192 9.87032C10.2325 9.87032 10 9.65162 10 9.38184C10 9.11205 10.2325 8.89335 10.5192 8.89335L17.2272 8.89335L15.3444 7.12199Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M4.65561 11.754C4.85838 11.9448 4.85838 12.2541 4.65561 12.4448C4.45284 12.6356 4.12408 12.6356 3.92131 12.4448L1.15208 9.83955C1.05069 9.74417 1 9.61916 1 9.49414C1 9.42791 1.01401 9.36475 1.0394 9.30716C1.06474 9.24954 1.1023 9.19556 1.15208 9.14873L3.92131 6.54347C4.12408 6.3527 4.45284 6.3527 4.65561 6.54347C4.85838 6.73423 4.85838 7.04353 4.65561 7.23429L2.77276 9.00566L9.48077 9.00565C9.76753 9.00565 10 9.22436 10 9.49414C10 9.76393 9.76753 9.98263 9.48077 9.98263L2.77276 9.98263L4.65561 11.754Z",
    fill: "#666666",
    stroke: "#666666",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.df41ab1784f06f51cedf4e12ec86ac4b.svg";
export { ForwardRef as ReactComponent };